import { createRoot } from "react-dom/client";

import {
  Navigate,
  BrowserRouter,
  Route,
  Routes,
  useParams,
} from "react-router-dom";

import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Countries from './pages/Countries';

import {ScrollTo } from "./components/ScrollTo";
import About from "./pages/About";

const PassRouteParams = ({ to: Component }) => {
  const params = useParams();
  return <Component {...params} />;
};

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <BrowserRouter>
      <ScrollTo>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/countries" element={<Countries />} />
          <Route path="/index.html" element={<Navigate to="/" />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ScrollTo>
  </BrowserRouter>
);
